<mat-expansion-panel [(expanded)]="panelExpanded">
    <mat-expansion-panel-header>
        <mat-panel-title>
            {{ 'billing.CRM.filter.title' | translate }}
            {{displayFilter}}
        </mat-panel-title>

        <mat-panel-description>
            {{ 'billing.CRM.filter.description' | translate }}
            <mat-icon>filter_list</mat-icon>
        </mat-panel-description>
    </mat-expansion-panel-header>

    <section class="filterSection">
        <form [formGroup]="filterForm" (submit)="onSubmitFilterForm()">
            <section class="filterInputs">
                <app-autocomplete [control]="filterForm.get('client')" [list]="clients"
                    label="billing.CRM.filter.client.label" errorMsg="billing.CRM.filter.client.errorMessage">
                </app-autocomplete>

                <mat-form-field>
                    <mat-label>{{'billing.CRM.filter.dateRange.label' | translate}}</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate formControlName="startDate" placeholder="Du" (focus)="picker.open()">
                        <input matEndDate formControlName="endDate" placeholder="Au" (focus)="picker.open()">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                    <mat-error>{{'billing.CRM.filter.dateRange.errorMessage' | translate}}</mat-error>
                </mat-form-field>

                <section class="filterBtns">
                    <button mat-raised-button type="submit" color="primary" [disabled]="filterForm.invalid"
                        matTooltip="Filtrer">
                        <mat-icon>
                            search
                        </mat-icon>
                        Filtrer
                    </button>

                    <button mat-icon-button color="primary" type="button" matTooltip="Effacer les filtres"
                        (click)="onClearFilters()">
                        <mat-icon>
                            clear
                        </mat-icon>
                    </button>
                </section>
            </section>
        </form>
    </section>
</mat-expansion-panel>